/** Feature token for the agent hub GA (production-ready) features */
export const AGENT_HUB_FEATURE_TOKEN = 'ai-agents';

/** Feature token for the agent hub development stage (unstable, dev-only features) */
export const AGENT_HUB_DEVELOPMENT_FEATURE_TOKEN = 'ai-agents-alpha';

/** Feature token for the agent hub early-access stage (stable pre-release features) */
export const AGENT_HUB_EARLY_ACCESS_FEATURE_TOKEN = 'ai-agents-beta';

/** Base path for the agent hub admin pages */
export const AGENT_HUB_ADMIN_BASE_PATH = 'agent-hub';

/** Feature token for the "studio" part of the agent hub (agent creation / edition) */
export const AI_AGENTS_STUDIO_FF = 'ai-agents-studio';

/** Custom events received while streaming `/chat` chunks */
export const CUSTOM_EVENTS = {
    /** The current agent requests to hand off the conversation to a different agent */
    AGENT_HANDOFF: 'agent_handoff_requested',
    /** The agent provides source document links used to generate an assistant message */
    ANSWER_RESOURCES: 'answer_resources',
    /** A run needs the user to authorize one or more connectors (OAuth consent) */
    CONSENT_REQUIRED: 'consent_required',
};
